/**
 * Pure ancestor selection for breadcrumbs, shared by the ERP's page header and the
 * shell's browser title (I-3777), both reading the `meta.breadcrumb` of the routes.
 * Given the current route's path PATTERN (e.g.
 * `/masterdata/companies/:companyId/branches/:branchId`) and all breadcrumb-bearing
 * route patterns, return the ancestor chain — every route whose pattern equals, or
 * is a `/`-delimited prefix of, the current pattern — ordered shortest→longest path.
 *
 * Unlike a param-less-only approach this KEEPS param'd intermediate levels
 * (`/companies/:companyId`, `/companies/:companyId/branches`), so a nested detail
 * page gets the full trail (Firmenstammdaten › Firma #123 › Niederlassungen ›
 * Niederlassung #456) instead of skipping the middle. Matching on patterns (not
 * concrete paths) also means we only ever resolve real routes, avoiding
 * router.resolve() "No match found" dev warnings for segments like `/masterdata`.
 */
export function selectBreadcrumbTrail<T extends { path: string }>(
  currentPattern: string,
  breadcrumbRoutes: readonly T[],
): T[] {
  return breadcrumbRoutes
    .filter(
      (r) =>
        currentPattern === r.path || currentPattern.startsWith(`${r.path}/`),
    )
    .sort((a, b) => a.path.length - b.path.length);
}
